<template>
	<div>
		  <header class="lmy-header lmy-header-w">
	        <i class="iconfont icon-back" onclick="window.history.go(-1)"></i>
	        历史记录
	        <span class="cancel" @click="clear()">清空</span>
	    </header>
	    <div class="lmy-collect">
        <div class="lmy-collect-list"  v-for="(item, index) in hotelViewHistoryList" >
          <div class="collect-title">{{item.date|dateToYMD}}{{item.date|dateWeekFormat}}</div>
          <div class="collect-box">
            <div class="check-box">
              <input type="checkbox">
            </div>
            <div :class="ActionBoxShow == index?'action-box action-box-show':'action-box'">
              <div class="share" style="display: none">分享</div>
              <div class="delete" @click="deleteList(index)" style="float: right">删除</div>
            </div>
            <div class="list-item" @click="routeToDetails(item)">
              <div class="item-img">
                <img :src="item.Pics[0].Url|replaceImgSrc(3)" v-if="item.Pics && item.Pics[0]" alt="">
                <img src="./../../../assets/img/default-hotel.jpg" v-if="!item.Pics||!item.Pics[0]||item.Pics[0].Url=='/'" alt="">
                <span class="tag" v-if="item.RecommendLevel"></span>
              </div>
              <div class="item-content">
                <h3 class="title">{{item.HotelName}}</h3>
                <p class="score"><span>{{item.CommRate}} {{item.Evaluation}}</span> {{item.HotelLevel}}</p>
                <p class="distance">{{item.Distance}}</p>
                <p class="address"  v-if="item.From==1">{{item.DistrictName}} | {{item.Landmark}}</p>
                <div class="config">
                  <i v-for="it in item.Facilities" :class="'iconfont icon-f-'+it"></i>
                </div>
                <div class="status" v-if="item.Attr!=0&&item.Attr">
                  <!--<span class="status-item">连住优惠</span>-->
                  <img class="icon-price-tags" v-if="(item.Attr & 1)==1" src="./../../../assets/img/lian.svg" />
                  <img class="icon-price-tags" v-if="(item.Attr & 2)==2" src="./../../../assets/img/zao.svg"  />
                  <img class="icon-price-tags" v-if="(item.Attr & 4)==4" src="./../../../assets/img/tuan.svg" />
                </div>
                <div class="price" v-if="item.From==1">¥<span>{{item.LowestPrice}}</span>起</div>
              </div>
            </div>
          </div>
        </div>


	       <!--  <ul class="lmy-bottom-select">
	            <li> 过去1天</li>
	            <li> 过去1周</li>
	            <li> 全部</li>
	        </ul>
	        <div class="lmy-mask-s"></div> -->
	    </div>
	</div>

</template>
<script>
	export default{
		name:'history',
		data(){
			return{
				hotelViewHistoryList: this.dao.get('hotelViewHistory') ? JSON.parse(this.dao.get('hotelViewHistory')) : '',
        CheckIn:this.getDate(1),
        CheckOut:this.getDate(2),
        ActionBoxShow:null,
        ActionBoxList:null,
			}
		},
    mounted(){
      this.onMouse()
    },
    methods:{
		  //全部清空
		  clear(){
        this.hotelViewHistoryList = ''
		    this.dao.set('hotelViewHistory','')
      },
      //进入详情页
      routeToDetails(item){

        if(item.From==0){
              var obj={
                HotelID:item.ID,
                ProductType:0,
                From:0,
                CheckIn:this.CheckIn,
                CheckOut:this.CheckOut,
                RoomCount:1,
                AdultCount:2,
                ChildrenCount:0,
                ChildrenAges:'',
              }

              this.dao.set('frHotelDetailsParams',JSON.stringify(obj));

              this.$router.push('/frHotelDetails');
        }else{
          var obj={
            HotelID:item.ID,
            ProductType:0,
            From:1,
            CheckIn:this.CheckIn,
            CheckOut:this.CheckOut,
            RoomCount:1,
            AdultCount:2,
            ChildrenCount:0,
            ChildrenAges:-1,
          }

          this.dao.set('hotelDetailsParams',JSON.stringify(obj));

          this.$router.push('/hotelDetails');

        }


      },

      //删除一项
      deleteList(index){
        this.ActionBoxShow = null;
        this.hotelViewHistoryList.splice(index,1);
        this.dao.set('hotelViewHistory',JSON.stringify(this.hotelViewHistoryList));
      },
      //左右滑动
      onMouse(){
		    var that = this;
		    var cbox = document.getElementsByClassName('collect-box');
		    for(let i = 0; i < cbox.length; i++){
          cbox[i].addEventListener('touchstart', touch, false);
          cbox[i].addEventListener('touchend', touch, false);
          var pagex;
          function touch(event) {
            var event = event || window.event;
            switch (event.type) {
              case "touchstart":
                pagex = event.touches[0].clientX;
                break;
              case "touchend":
                if (event.changedTouches[0].clientX - pagex > 10) {
                  if(that.ActionBoxList == i){
                    that.ActionBoxShow = null
                  }
                } else if (event.changedTouches[0].clientX - pagex < -10) {
                  that.ActionBoxShow = i;
                  that.ActionBoxList = i;
                }
                break;
              case "touchmove":
                event.preventDefault();
                break;
            }
          }
        }
      },
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/usr/history/history.vue